/**
 * @file
 * Global Skazy skazy utilities.
 */

import {
  CustomBounce,
  CustomEase,
  CustomWiggle,
  DrawSVGPlugin,
  EaselPlugin,
  EasePack,
  MorphSVGPlugin,
  ScrambleTextPlugin,
  ScrollSmoother,
  SplitText
} from "../gsap-business/gsap-compressed-minify";

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.addAccessionBehavior = {
    attach: function (context, settings) {
      bodyPositionToggle();
    }
  };

  function bodyPositionToggle() {
    const body = document.querySelector('body');
    const menuBurger = document.querySelector('.menu-burger');
    const menuBurgerClose = document.querySelector('.menu-burger-close');

    menuBurger.addEventListener('click', function() {
      body.classList.add('menuresponsive');
    });

    menuBurgerClose.addEventListener('click', function() {
      body.classList.remove('menuresponsive');

    });
  }

  document.addEventListener("DOMContentLoaded", function() {
        var cookieElements = document.querySelectorAll(".cookie");
        function handleCookieClick() {
            tarteaucitron.userInterface.openPanel();
        }

        for (var i = 0; i < cookieElements.length; i++) {
            var cookieElement = cookieElements[i];

            // Remove the href attribute
            cookieElement.removeAttribute("href");

            // Add click event listener
            cookieElement.addEventListener("click", handleCookieClick);
        }
    });

})(jQuery, Drupal);
